import React from "react";
import Back from "../common/Back";
import img from "../images/about.jpg";

const images = [
  "../images/gallery1.jpg",
  "../images/gallery2.jpg",
  "../images/gallery3.jpg",
  "../images/gallery4.jpg",
  "../images/gallery5.jpg",
  "../images/gallery6.jpg",
  "../images/gallery7.jpg",
  "../images/gallery8.jpg",
  "../images/gallery9.jpg",
  "../images/gallery10.jpg",
  "../images/gallery11.jpg",
  "../images/gallery12.jpg",
  "../images/gallery13.jpg",
  "../images/gallery14.jpg",
  "../images/gallery15.jpg",
  "../images/gallery16.jpg",
  "../images/gallery17.jpg",
  "../images/gallery18.jpg",
  "../images/gallery19.jpg",
  "../images/gallery20.jpg",
];

const galleryStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
  gap: "15px",
  padding: "20px",
};

const itemStyle = {
  borderRadius: "8px",
  overflow: "hidden",
  transition: "transform 0.3s ease-in-out",
};

const imgStyle = {
  width: "100%",
  height: "auto",
  display: "block",
};

const Gallery = () => {
  return (
    <>
      <section className="gallery-out mb">
        <Back name="Gallery" title="Gallery Grid - Our Collections" cover={img} />
        <div style={galleryStyle}>
          {images.map((src, index) => (
            <div
              key={index}
              style={itemStyle}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
              onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              <img src={src} alt={`Gallery ${index + 1}`} style={imgStyle} />
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Gallery;
